<template>
  <div v-if="data">
    <form  autocomplete="off">

      <div class="row">

          <!-- <div
          class="col-md-3"
           v-if="data.id"
        >
          <form-group-image
            :url="url+'user/app/creditcard/image/'+data.id"
            :value="data.ImageURL"
            img-type="square"
          />
        </div> -->

        <!-- "holder_name": "José da Silva",
  "card_expiration": "12/2023",
  "card_number": "5167454851671773",
  "card_cvv": "123",
  "registry_code":"094.262.787-37" -->

        <div class="col-md-4">
            <fg-input
            class="clean"
            type="text"
            label="Número"
            placeholder=""
            v-mask="'#### #### #### ####'"
            v-model="data.card_number"
            v-bind:readonly="readonly"

          />
        </div>

        <div class="col-md-4">
            <fg-input
            class="clean"
            type="text"
            label="Validade"
            placeholder=""
            v-mask="'##/####'"
            v-model="data.card_expiration"
            v-bind:readonly="readonly"

          />
        </div>

        <div class="col-md-4">
            <fg-input
            class="clean"
            type="text"
            label="CVV"
            placeholder=""
            v-mask="'###'"
            v-model="data.card_cvv"
            v-bind:readonly="readonly"

          />
        </div>

        <div class="col-md-6">
            <fg-input
            class="clean"
            type="text"
            label="Titular"
            placeholder="Nome do titular do cartão"
            v-model="data.holder_name"
            v-bind:readonly="readonly"

          />
        </div>

        <div class="col-md-6">
            <fg-input
            class="clean"
            type="text"
            label="CPF do titular"
            placeholder=""
            v-mask="'###.###.###-##'"
            v-model="data.registry_code"
            v-bind:readonly="readonly"

          />
        </div>

    
        <div class="text-right">
      <btn-rounded
        v-if="!readonly"
        label="SALVAR"
        event="execute"
      />
    </div>

  </div>


    </form>
  </div>
</template>

<script>
  import {
    mapActions,
    mapState,
    mapGetters
  } from "vuex";
  import moment from 'moment';
  import { NAMES } from '../../../config';

  export default {
    name: "salary-form",
    components: {
    
    },

    props: {
      data: {
        type: Object,
      },
      readonly: {
        type: Boolean,
        default: false
      },
      event: {
        type: String,
        default: ''
      },
      edit: {
        type: Boolean,
        default: false
      },
       url: {
        type: String,
        default: NAMES.fullUrl
      }
    },

    computed: {
      ...mapState({
       
      })
    },

    methods: {
      ...mapActions([""]),
      ...mapGetters({
        sidebarFlag: 'sidebarFlag'
      }),
  
      formatDate(date) {
        return moment.utc(date).utcOffset(0).format('DD/MM/YYYY HH:mm:ss')
      },

      format: function (sValue) {
        this.data.formattedValueCentavos = parseInt(("" + sValue).onlyNumber()).int2Money();
        this.data.valueCentavos = this
          .data
          .formattedValueCentavos
          .replace("R$", "")
          .replace(",", "")
          .replace(".", "")
          .replace(" ", "");
        this.$nextTick(() => {
        });
      
      },

      // execute() {
      //   console.log("x")
      //   if (this.event) {
          

      //     this.$parent.$emit(this.event, this.data);
      //   }
      // },
    },

    created() {

      this.$on("execute", () => {
  // "holder_name": "José da Silva",
  // "card_expiration": "12/2023",
  // "card_number": "5167454851671773",
  // "card_cvv": "123",
  // "registry_code":"094.262.787-37" 

        if(this.event){

          if(!this.data.card_number || this.data.card_number == ""){
           return this.$notify({
                group: "foo",
                title: "Atenção",
                text: "Campo Número do Cartão é obrigatório",
                position: "top center",
                type: "warn"
              });
        }

        if(!this.data.card_expiration || this.data.card_expiration == ""){
           return this.$notify({
                group: "foo",
                title: "Atenção",
                text: "Campo Validade é obrigatório",
                position: "top center",
                type: "warn"
              });
        }

        if(!this.data.card_cvv || this.data.card_cvv == ""){
           return this.$notify({
                group: "foo",
                title: "Atenção",
                text: "Campo CVV é obrigatório",
                position: "top center",
                type: "warn"
              });
        }

        if(!this.data.holder_name || this.data.holder_name == ""){
           return this.$notify({
                group: "foo",
                title: "Atenção",
                text: "Campo Nome do Titular é obrigatório",
                position: "top center",
                type: "warn"
              });
        }

          if(!this.data.registry_code || this.data.registry_code == ""){
           return this.$notify({
                group: "foo",
                title: "Atenção",
                text: "Campo CPF do Titular é obrigatório",
                position: "top center",
                type: "warn"
              });
        }

    

      

        this.$parent.$emit(this.event, this.data);

        }
      });

    },
    data() {
      return {
        localReadonly: false,
      
      };
    },

  };
</script>

<style scoped lang="scss">

label.stronger {
  font-weight: bold;
  color: black;
}

.stronger {
  font-weight: bold;
  color: black;
  margin: 15px 0 0 0 !important;
}

p.subject {
  color: #9c9c9c;
}

</style>



// WEBPACK FOOTER //
// src/components/UIComponents/Forms/CreditCardForm.vue